document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-editorial-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (!track) return;

    function slideWidth() {
      var slide = track.querySelector('[data-carousel-slide]');
      return slide ? slide.getBoundingClientRect().width + 8 : 0;
    }

    prev && prev.addEventListener('click', function () {
      track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
    });

    next && next.addEventListener('click', function () {
      track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
    });
  });
    var revealTargets = document.querySelectorAll('.scroll-reveal');
  if (revealTargets.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    revealTargets.forEach(function (el) { observer.observe(el); });
  }
    document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var header = btn.closest('.site-header');
      header.classList.toggle('is-menu-open');
    });
  });
});
